import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { ApplicationState } from '@/redux/stores/types'

import { IAction } from '../actions/action-helpers'
import { HotelsRatesTypes } from '../actions/actions.types'

type HotelsRatesState = ApplicationState['hotelsRates']

function hotelsRatesReducer(state: HotelsRatesState = new ImmutableMap(), action: IAction): HotelsRatesState {
	let hotelId: string
	let searchId: number
	switch (action.type) {
		case HotelsRatesTypes.GetHotelRates.SUCCESS:
			hotelId = action.requestPayload.hotelId
			searchId = action.requestPayload.searchId
			return state.set([searchId, hotelId].join('-'), action.payload)
	}
	return state
}

export default hotelsRatesReducer
